import { useState } from "react"
import { Stack, TextField } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { StandardButton } from "../../../../../../../shared/components/buttons/StandardButton"
import { StandardDialog } from "../../../../../../../shared/components/dialogs/StandardDialog"

import { LabeledDialogField } from "./LabeledDialogField"

const useStyles = makeStyles()(() => ({
    content: {
        padding: "0 1.5rem 1.5rem",
    },
}))

type Props = Readonly<{
    open: boolean
    dishName: string
    initialValue: string
    onSave: (value: string) => void
    onClose: () => void
}>

/** The full-text editor for cell descriptions, which the inline field shows shortened. */
export function DescriptionDialog({ open, dishName, initialValue, onSave, onClose }: Props) {
    const { classes } = useStyles()
    const [value, setValue] = useState(initialValue)

    return (
        <LocalizedStrict id="merchant-week-menu-description-dialog" attrs={{ dialogTitle: true }}>
            <StandardDialog open={open} dialogTitle="Edit Description" subtitle={dishName} onClose={onClose}>
                <Stack spacing="1.5rem" className={classes.content}>
                    <LabeledDialogField labelId="merchant-week-menu-description-dialog-field-label" label="Description">
                        <LocalizedStrict id="merchant-week-menu-description-dialog-field" attrs={{ placeholder: true }}>
                            <TextField
                                value={value}
                                placeholder="Write a longer, more detailed description here…"
                                multiline
                                minRows={6}
                                fullWidth
                                onChange={(event) => setValue(event.target.value)}
                            />
                        </LocalizedStrict>
                    </LabeledDialogField>
                    <Stack direction="row" spacing=".75rem">
                        <LocalizedStrict id="merchant-week-menu-description-dialog-close-button">
                            <StandardButton variant="outlined" color="black" onClick={onClose}>
                                Close
                            </StandardButton>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-week-menu-description-dialog-save-button">
                            <StandardButton onClick={() => onSave(value)}>Save</StandardButton>
                        </LocalizedStrict>
                    </Stack>
                </Stack>
            </StandardDialog>
        </LocalizedStrict>
    )
}
